module.exports = __webpack_public_path__ + "assets/remove.8477f238.svg";